
module.exports = function(app) {

  return new Promise(resolve => {

    app.modBInfo = 'meow';
    resolve({
      endpoints: [
        {
          path: '/meow',
        },
      ],
    });
  });
};
